console.log("pixiInitialize");
// TODO device manager
var ios = !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
if (ios) {
    PIXI.settings.PRECISION = PIXI.PRECISION.HIGH;
}
PIXI.settings.GC_MODE = PIXI.GC_MODES.AUTO;



/** WEBPACK FOOTER **
 ** ./Engine/Game/PixiSettings.ts
 **/